import { useContext } from 'react';
import { LoginModalContext } from 'context/loginModal';

const useLoginModalContext = () => {
  return useContext(LoginModalContext);
};

export default useLoginModalContext;
